import { render, staticRenderFns } from "./business-intro.vue?vue&type=template&id=0c70db32&scoped=true&"
import script from "./business-intro.vue?vue&type=script&lang=js&"
export * from "./business-intro.vue?vue&type=script&lang=js&"
import style0 from "./business-intro.vue?vue&type=style&index=0&id=0c70db32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70db32",
  null
  
)

export default component.exports